import { render, staticRenderFns } from "./GasDetailDialog.vue?vue&type=template&id=40d00c7a&scoped=true&"
import script from "./GasDetailDialog.vue?vue&type=script&lang=js&"
export * from "./GasDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./GasDetailDialog.vue?vue&type=style&index=0&id=40d00c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d00c7a",
  null
  
)

export default component.exports